/* Экран карты. Цвета — только токены; единственная вычисляемая палитра
   (цвет массива) приходит из mapModel и живёт в inline-стиле образца. */

.workspace {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
  gap: var(--sp-4);
  align-items: start;
}

/* Рамка полотна: сюда же приклеены плашки, поэтому позиционирование здесь. */
.frame {
  position: relative;
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-card);
  overflow: hidden;
  background: var(--canvas);
}

.canvas {
  position: relative;
  width: 100%;
  /* Высоту задаёт экран: у полноэкранной карты она одна, у обзорного кадра
     другая. Переменная — объявленный шов; лезть в чужой класс снаружи нельзя. */
  height: var(--map-canvas-height, clamp(420px, 62vh, 760px));
  /* Подложка карты — фон контейнера: в стиле maplibre нет ни одного слоя,
     канва прозрачна, и цвет приходит из палитры продукта, а не из WebGL. */
  background: var(--canvas);
}

/* Подсказка рисуется своим div поверх канвы: символьных слоёв в стиле нет,
   а Popup maplibre принёс бы собственное оформление мимо дизайн-системы. */
.tip {
  position: absolute;
  z-index: 3;
  max-width: 260px;
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-inner);
  background: var(--card);
  box-shadow: var(--shadow-card);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
  pointer-events: none;
}

.tipTitle {
  font-weight: 700;
  font-size: var(--type-body-size);
  line-height: var(--type-body-line);
}

.tipMuted {
  color: var(--muted);
  font-style: italic;
}

.tipFoot {
  margin-top: var(--sp-1);
  padding-top: var(--sp-1);
  border-top: 1px solid var(--color-border-subtle);
  color: var(--muted);
}

/* Общая геометрия: тот же полигон виден у нескольких контуров. Без этой строки
   одинаковые полигоны у соседей читаются как ошибка данных, а не как отношение. */
.tipShared {
  margin-top: 2px;
  color: var(--copper-deep);
}

/* Нижние пометки стоят стопкой: их может быть две (производная геометрия и
   синтетическая раскраска), и вторая не имеет права закрыть первую. */
.plateStack {
  position: absolute;
  z-index: 2;
  left: var(--sp-3);
  right: var(--sp-3);
  bottom: var(--sp-3);
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

/* Пометка о производности геометрии видна всегда, пока видна сама карта. */
.derivedPlate {
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid var(--copper-deep);
  border-radius: var(--radius-inner);
  background: var(--copper-soft);
  color: var(--brown-ink);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

.statusPlate {
  position: absolute;
  z-index: 2;
  left: var(--sp-3);
  top: var(--sp-3);
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-1) var(--sp-3);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-pill);
  background: var(--card);
  box-shadow: var(--shadow-card);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
  font-variant-numeric: tabular-nums;
}

/* Отказ слоя объявляется поверх канвы: молча пустая карта читается как
   «данных нет», а это неправда. */
.failurePlate {
  position: absolute;
  z-index: 4;
  left: var(--sp-3);
  right: var(--sp-3);
  top: var(--sp-3);
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid var(--copper-deep);
  border-radius: var(--radius-inner);
  background: var(--card);
  color: var(--brown-ink);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

.legend {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.legendRow {
  display: flex;
  align-items: baseline;
  gap: var(--sp-2);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

.legendName {
  min-width: 0;
  overflow-wrap: anywhere;
}

.legendCount {
  margin-left: auto;
  color: var(--muted);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.swatch {
  flex: 0 0 auto;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid var(--line-strong);
  /* Заливка слоя полупрозрачна — образец приглушён так же, иначе легенда
     обещала бы цвет, которого на карте нет. */
  opacity: 0.75;
}

/* Свёрнутая легенда массивов удалена вместе с `<details>`: легенда тематики
   видна всегда и называет цвета КАДРА, а не весь справочник района. */

/* Кликабельна вся строка списка: ссылка растянута на строку таблицы (строка
   позиционирована), поэтому целиться в узкий номер не нужно. */
.rowLink::after {
  content: "";
  position: absolute;
  inset: 0;
}

/* Образец обводки яруса: та же толщина и та же штриховка, что на карте. */
.tierSample {
  flex: 0 0 auto;
  width: 22px;
  border-bottom-style: solid;
}

.tierAuto {
  border-bottom-width: 1px;
  border-bottom-color: var(--muted);
}

.tierScored {
  border-bottom-width: 2px;
  border-bottom-color: var(--ink);
}

.tierGroup {
  border-bottom-width: 2px;
  border-bottom-style: dashed;
  border-bottom-color: var(--copper-deep);
}

/* Ярусы, где ОДНА геометрия принадлежит нескольким контурам. Они отделены от
   auto/scored/group не оттенком, а рисунком линии: разница между «часть одного
   контура» и «общая для нескольких» — это разные утверждения, и легенда обязана
   их развести. Рисунок повторяет штриховку соответствующего слоя карты. */
.tierMerge {
  border-bottom-width: 2px;
  border-bottom-style: dotted;
  border-bottom-color: var(--copper-active);
}

.tierMn {
  align-self: center;
  height: 2px;
  border-bottom-style: none;
  background-image: linear-gradient(
    to right,
    var(--brown-ink) 0 8px,
    transparent 8px 11px,
    var(--brown-ink) 11px 13px,
    transparent 13px 16px
  );
  background-size: 16px 2px;
  background-repeat: repeat-x;
}

/* Ярус, которого нет в реестре интерфейса. Он не исчезает: у него собственный
   образец и подпись «неизвестно: код». */
.tierUnknown {
  border-bottom-width: 2px;
  border-bottom-style: dashed;
  border-bottom-color: var(--gis-missing);
  opacity: 0.6;
}

.contextSample {
  flex: 0 0 auto;
  width: 22px;
  border-bottom: 2px solid var(--deep);
}

.contextSampleSoft {
  flex: 0 0 auto;
  width: 22px;
  height: 14px;
  border: 1px solid var(--line-strong);
  background: var(--sage);
}

@media (max-width: 1279px) {
  .workspace {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Пометка демо-слоя: видна всё время, пока карта раскрашена синтетикой.
   Штриховка та же, что у значка «демо», — одна и та же вещь обязана
   выглядеть одинаково на карте и в карточке. */
.demoPlate {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid var(--color-control-border);
  border-radius: var(--radius-inner);
  background: var(--card);
  background-image: repeating-linear-gradient(
    45deg,
    transparent 0 6px,
    var(--series-track) 6px 9px
  );
  color: var(--ink);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

/* Строка демо в подсказке: та же штриховка, что и у плашки и у значка. */
.tipDemo {
  margin-top: var(--sp-1);
  padding: 2px var(--sp-1);
  border-radius: var(--radius-inner);
  background-image: repeating-linear-gradient(
    45deg,
    transparent 0 4px,
    var(--series-track) 4px 6px
  );
}

/* Переключатель демо-слоя удалён: тематика выбирается общим `Select`, а не
   галочкой — раскраска это ОДИН слой с несколькими темами, а не набор
   независимых слоёв. */

/* Подпись партии демо: происхождение синтетики рядом с её числами. */
.batchNote {
  margin: 0;
  color: var(--muted);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

/* Снятие локального фильтра карты: кнопка внутри строки текста, а не рядом с
   ней — иначе на узком экране она отрывается от объяснения, которое отменяет. */
.filterReset {
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  color: var(--text-link);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* --- Превью контура в правой панели ---------------------------------- */

/* Превью отвечает на «что это за контур», не отбирая кадр карты. Величины те
   же, что в подсказке под курсором: расходиться в словах им нельзя. */
.preview {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  min-width: 0;
}

.previewMarks {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
}

.previewList {
  display: grid;
  grid-template-columns: minmax(7rem, auto) minmax(0, 1fr);
  gap: var(--sp-2) var(--sp-3);
  margin: 0;
}

.previewList dt {
  color: var(--muted);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

.previewList dd {
  margin: 0;
  overflow-wrap: anywhere;
  min-width: 0;
}

/* Отсутствие значения выглядит как отсутствие, а не как значение. */
.previewMuted {
  color: var(--muted);
  font-style: italic;
}

/* Синтетика в превью — та же штриховка, что на плашке карты и на значке ДЕМО:
   одна и та же вещь обязана выглядеть одинаково везде. */
.previewDemo {
  padding: 2px var(--sp-1);
  border-radius: var(--radius-inner);
  background-image: repeating-linear-gradient(
    45deg,
    transparent 0 4px,
    var(--series-track) 4px 6px
  );
}

.previewNote {
  margin: 0;
  color: var(--muted);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

/* --- Ширина полотна на широком экране -------------------------------- */

/* На 27" правая колонка занимала треть экрана и держала легенду, которая её не
   заполняет: полотну доставалось меньше места, чем на ноутбуке. Легенда
   фиксируется, лишняя ширина уходит карте — она и есть предмет экрана. */
@media (min-width: 1600px) {
  .workspace {
    grid-template-columns: minmax(0, 1fr) var(--w-rail);
  }

  .canvas {
    height: var(--map-canvas-height, clamp(520px, 68vh, 900px));
  }
}

/* --- Переходы «то же списком» (DC-06) --------------------------------- */

.crossLinks {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2) var(--sp-4);
  margin-top: var(--sp-3);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

/* --- Таблица-компаньон ------------------------------------------------ */

/* Клавиатурный эквивалент полотна. Строка — кнопка во всю ширину: целиться в
   номер не нужно ни мышью, ни пальцем, а фокус виден рамкой, а не только
   подсветкой на карте (её человек с клавиатурой может не увидеть вовсе). */
.frameList {
  list-style: none;
  margin: var(--sp-3) 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.frameRow {
  display: grid;
  grid-template-columns: minmax(90px, 0.8fr) minmax(120px, 1.4fr) minmax(0, 2fr) minmax(90px, 0.8fr);
  gap: var(--sp-3);
  align-items: baseline;
  width: 100%;
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid transparent;
  border-radius: var(--radius-inner);
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.frameRow:hover {
  background: var(--soft);
  border-color: var(--color-border-subtle);
}

.frameRow:focus-visible {
  outline: 2px solid var(--line-focus);
  outline-offset: 1px;
}

.frameNo {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.frameCell {
  min-width: 0;
  overflow-wrap: anywhere;
}

.frameArea {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 720px) {
  .frameRow {
    grid-template-columns: minmax(0, 1fr);
    gap: 2px;
  }

  .frameArea {
    text-align: left;
  }
}

/* --- Переходы уровня внутри превью ------------------------------------ */

/* Ссылки стоят в теле карточки, а не только в закреплённой строке действия:
   «а чей это массив» — вопрос, который задают, ещё не решив открывать контур. */
.previewLinks {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

/* Шапка таблицы-компаньона: та же сетка, что у строки, но не кнопка. */
.frameHead {
  color: var(--muted);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
  font-weight: 600;
  cursor: default;
  border-bottom: 1px solid var(--color-border-subtle);
  border-radius: 0;
}

/* ---------- Подложка (agroai-gpo.7.10) ---------- */

/* Инструменты полотна — ОДНА колонка у правого края (agroai-6al.38):
   масштаб (+/−), затем кнопки кадра (`--map-tools-offset` задаёт общий кадр
   AgroMap, у которого есть «развернуть»), затем подложка тремя иконками.
   Размеры — общие переменные, чтобы колонка шла ровно, без зазубрин. */
.canvas {
  --map-tool-size: 30px;
  --map-tool-gap: var(--sp-2);
  --map-zoom-height: calc(2 * var(--map-tool-size) + 3px);
}

.canvas :global(.maplibregl-ctrl-top-right .maplibregl-ctrl) {
  margin: var(--sp-3) var(--sp-3) 0 0;
}

.canvas :global(.maplibregl-ctrl-group:not(:empty)) {
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-inner);
  box-shadow: var(--shadow-card);
  overflow: hidden;
}

.canvas :global(.maplibregl-ctrl-group button) {
  width: var(--map-tool-size);
  height: var(--map-tool-size);
}

/* Слева живут подпись кадра, панель слоёв и легенда — колонка их не трогает. */
.basemap {
  position: absolute;
  z-index: 3;
  right: var(--sp-3);
  top: calc(var(--sp-3) + var(--map-tools-offset, 0px));
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--sp-1);
  max-width: min(260px, 60%);
}

.basemapInteractive {
  top: calc(
    var(--sp-3) + var(--map-zoom-height) + var(--map-tool-gap) + var(--map-tools-offset, 0px)
  );
}

.basemapGroup {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-inner);
  background: var(--card);
  box-shadow: var(--shadow-card);
  overflow: hidden;
}

.basemapButton {
  display: grid;
  place-items: center;
  width: var(--map-tool-size);
  height: var(--map-tool-size);
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--muted);
  font: inherit;
  cursor: pointer;
}

.basemapButton + .basemapButton {
  border-top: 1px solid var(--color-border-subtle);
}

.basemapButton[data-hovered] {
  background: var(--soft);
  color: var(--ink);
}

.basemapIcon {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
}

.basemapButton[data-selected] {
  background: var(--sage);
  color: var(--deep);
  box-shadow: inset 2px 0 0 var(--active);
}

.basemapButton[data-focus-visible] {
  outline: 2px solid var(--gis-selection);
  outline-offset: -2px;
}

/* «Подложка недоступна» — отказ ФОНА, а не карты: плашка тише, чем отказ
   слоя, и не закрывает полотно. */
.basemapNotice {
  padding: var(--sp-1) var(--sp-2);
  border: 1px dashed var(--line-strong);
  border-radius: var(--radius-inner);
  background: var(--card);
  color: var(--muted);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

/* Атрибуция обязательна лицензией CC BY 4.0 и видна, пока виден снимок. */
.attribution {
  position: absolute;
  z-index: 2;
  right: 0;
  bottom: 0;
  max-width: 100%;
  padding: 2px var(--sp-2);
  background: var(--card);
  color: var(--muted);
  font-size: 10px;
  line-height: 14px;
  opacity: 0.9;
}

/* Подпись района поверх карты (agroai-0yt.2): HTML-маркер, потому что у
   стиля нет глифов. Гало — цветом карточки, как у двойной обводки границы;
   клики проходят сквозь подпись к контурам. */
.districtLabel {
  pointer-events: none;
  font-size: 13px;
  font-weight: 650;
  letter-spacing: 0.02em;
  color: var(--ink);
  text-shadow:
    0 0 2px var(--card),
    0 0 4px var(--card),
    0 0 6px var(--card);
  white-space: nowrap;
}
